export enum CourseLevelEnum{
    BachelorsDegree,
    BachelorsAndMastersDegree,
    Certificate,
    Diploma,
    DoctoralDegree,
    DualDegree,
    FoundationDegree,
    MastersDegree,
    PostgraduateCertificate,
    PostgraduateDiploma,
    PreSessionalProgram,
    UndergraduateCertificate,
    UndergraduateDiploma,
    Vocational
}

export const CourseLevelEnumDescriptions: { [key in CourseLevelEnum]: string} = {
    [CourseLevelEnum.BachelorsDegree]: "Bachelor's Degree",
    [CourseLevelEnum.BachelorsAndMastersDegree]: "Bachelor's Degree & Master's Degree",
    [CourseLevelEnum.Certificate]: "Certificate",
    [CourseLevelEnum.Diploma]: "Diploma",
    [CourseLevelEnum.DoctoralDegree]: "Doctoral Degree",
    [CourseLevelEnum.DualDegree]: "Dual Degree",
    [CourseLevelEnum.FoundationDegree]: "Foundation Degree",
    [CourseLevelEnum.MastersDegree]: "Master's Degree",
    [CourseLevelEnum.PostgraduateCertificate]: "Postgraduate Certificate",
    [CourseLevelEnum.PostgraduateDiploma]: "Postgraduate Diploma",
    [CourseLevelEnum.PreSessionalProgram]: "Pre-sessional program",
    [CourseLevelEnum.UndergraduateCertificate]: "Undergraduate Certificate",
    [CourseLevelEnum.UndergraduateDiploma]: "Undergraduate Diploma",
    [CourseLevelEnum.Vocational]: "Vocational"
};

/**
 * Returns the CourseLevelEnum for a given description string (e.g. "Bachelor's Degree").
 * Returns undefined if no matching enum is found.
 */
export function getCourseLevelEnumFromDescription(description: string): CourseLevelEnum | undefined {
    const trimmed = (description ?? '').trim();
    if (!trimmed) return undefined;
    const entry = (Object.entries(CourseLevelEnumDescriptions) as [string, string][])
        .find(([, value]) => value === trimmed);
    return entry ? (Number(entry[0]) as CourseLevelEnum) : undefined;
}